var React = require('react');

function Generic (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32.348 1.49278C29.748 0.528094 26.9359 0 24.0002 0C21.0645 0 18.2524 0.528094 15.6524 1.49278L13.5654 24L15.6524 46.5072C18.2524 47.472 21.0645 48 24.0002 48C26.9359 48 29.748 47.472 32.348 46.5072L34.4349 24L32.348 1.49278Z","fill":"#E9E8E8","key":0}),React.createElement("path",{"d":"M47.9999 24C47.9999 13.681 41.4869 4.88386 32.3477 1.49292V46.5075C41.4869 43.1162 47.9999 34.3193 47.9999 24Z","fill":"#ABABAB","key":1}),React.createElement("path",{"d":"M0 24C0 34.3193 6.513 43.1162 15.6522 46.5074V1.49292C6.513 4.88386 0 13.681 0 24Z","fill":"#ABABAB","key":2})]);
}

Generic.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Generic;

Generic.default = Generic;
